import logoOriginal from "@/assets/lorier-logo.svg";
import loginIllustrationBackground from "@/assets/login-illustration-background.png";
import loginIllustration from "@/assets/login-illustration-2.png";
import loginIllustrationIcon from "@/assets/login-illustration-icon.svg";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ROUTES } from "@/constants/routes";
import RequestResetForm from "@/features/auth/components/forms/request-reset-form";
import VerifyCodeForm from "@/features/auth/components/forms/verify-code-form";
import CompleteResetForm from "@/features/auth/components/forms/complete-reset-form";

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [step, setStep] = useState<1 | 2 | 3>(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");

  const stepTitles: Record<1 | 2 | 3, string> = {
    1: t("modules.auth.forgot_password.step1_title"),
    2: t("modules.auth.forgot_password.step2_title"),
    3: t("modules.auth.forgot_password.step3_title"),
  };

  return (
    <main className="h-screen w-full flex">
      <section className="flex-1 flex flex-col items-center lg:justify-center pt-30 lg:pt-0 bg-white px-8">
        <img src={logoOriginal} alt="Lorier Logo" className="w-30 md:w-40" />
        <h3 className="text-2xl font-bold my-8">{stepTitles[step]}</h3>

        {step === 1 && (
          <RequestResetForm
            onSuccess={(submittedEmail) => {
              setEmail(submittedEmail);
              setStep(2);
            }}
          />
        )}

        {step === 2 && (
          <VerifyCodeForm
            email={email}
            onSuccess={(verifiedCode) => {
              setCode(verifiedCode);
              setStep(3);
            }}
            onBack={() => setStep(1)}
          />
        )}

        {step === 3 && (
          <CompleteResetForm
            email={email}
            code={code}
            onSuccess={() => {
              toast.success(t("modules.auth.forgot_password.reset_success"));
              navigate(ROUTES.LOGIN);
            }}
          />
        )}
      </section>
      <section className="flex-1 hidden lg:flex h-full bg-primary items-center justify-center relative pl-5">
        <img
          src={loginIllustrationBackground}
          className="absolute size-full w-full h-full inset-0"
        />
        <figure className="relative flex items-center w-96 justify-center">
          <img src={loginIllustration} className="w-full" />
          <img
            src={loginIllustrationIcon}
            className="absolute top-1/2 left-1/2 -translate-x-[216px] -translate-y-1/2"
          />
        </figure>
      </section>
    </main>
  );
};

export default ForgotPasswordPage;
